//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiReload,
  mdiTableColumn,
  mdiChevronDown,
  mdiChevronUp,
  mdiPencil,
  mdiDelete,
  mdiCancel,
  mdiClose,
} from '@mdi/js'

export default {
  name: 'Users',
  layout: 'default',
  data: () => ({
    icons: {
      mdiReload,
      mdiTableColumn,
      mdiChevronDown,
      mdiChevronUp,
      mdiPencil,
      mdiDelete,
      mdiCancel,
      mdiClose,
    },
    isLoading: false,
    valid: true,
    selected: [],
    checkAll: false,
    itemsPerPage: [10, 15, 30, 50],
    dataOptions: {
      itemsPerPage: 10,
      page: 1,
      serverItemsLength: 0,
    },
    timeout: null,
    dataColumns: {},
    selectedColumns: [],
    headers: [],
    dataItems: [],
    editedIndex: -1,
    editedItem: {
      ID: null,
      Email: null,
      Phone: null,
      Name: null,
      Surname: null,
      PeriodicReport: null,
      PeriodicReportSubOrganization: null,
      AutoSend: null,
      BreachesReport: null,
      BreachesReportSubOrganization: null,
      Language: null,
      NotificationTimeZoneID: null,
      TemperatureUnit: null,
      SkipAlerts: null,
      Organizations: [],
    },
    defaultItem: {
      ID: null,
      Email: null,
      Phone: null,
      Name: null,
      Surname: null,
      PeriodicReport: null,
      PeriodicReportSubOrganization: null,
      AutoSend: null,
      BreachesReport: null,
      BreachesReportSubOrganization: null,
      Language: null,
      NotificationTimeZoneID: null,
      TemperatureUnit: null,
      SkipAlerts: null,
      Organizations: [],
    },
    allRoles: [],
    allPeriodicReports: [],
    allBreachesReports: [],
    allLanguages: [],
    allAutoSends: [],
    allNotificationTimeZones: [],
    allTemperatureUnits: [],
    allOrganizations: [],
    selectedOrganization: [],
    DeleteGlobalError: '',
    GlobalError: '',
    formErrors: {} || null,
    userOrganizations: {
      OrganizationID: null,
      RoleID: null,
    },
    defaultUserOrganizations: {
      OrganizationID: null,
      RoleID: null,
    },
    showNewOrganization: false,
    userModalAccordionActions: [0],
    showControls: false,
  }),

  computed: {
    allItemIDs() {
      const ids = []
      this.dataItems.forEach((el) => {
        ids.push(el.ID)
      })
      return ids
    },
  },

  created() {
    this.initTranslations()
    this.$store.commit('layout/setTitle', this.$t('users.users'))
    this.showControls = this.$hasPermissions('users', 'modify')
  },

  mounted() {},

  methods: {
    initTranslations() {
      this.headers = [
        {
          text: this.$t('users.eMail'),
          align: 'start',
          sortable: true,
          value: 'Email',
          search: true,
          isDetailsLink: {
            page: 'users',
            url: '/users/details/?id=',
          },
          ownUserBadge: true,
          forceWidth: '345px',
          rwdWidth: {
            mobile: '250px',
            desktop: '345px',
          },
        },
        {
          text: this.$t('users_new.phone'),
          align: 'start',
          sortable: true,
          value: 'Phone',
          search: true,
          forceWidth: '150px',
        },
        {
          text: this.$t('users_new.type'),
          sortable: true,
          align: 'start',
          value: 'Type',
          select: true,
          forceWidth: '120px',
        },
        {
          text: this.$t('users.periodicalReport'),
          align: 'start',
          value: 'PeriodicReport',
          reportIcons: true,
          forceWidth: '120px',
        },
        {
          text: this.$t('users_new.breachesReport'),
          align: 'start',
          value: 'BreachesReport',
          reportIcons: true,
          forceWidth: '150px',
        },
        {
          text: this.$t('users_new.complianceReport'),
          align: 'start',
          value: 'ComplianceReport',
          reportIcons: true,
          forceWidth: '150px',
        },
        {
          text: this.$t('users.organization'),
          align: 'start',
          sortable: true,
          value: 'Organizations',
          OrganizationList: true,
          search: true,
          forceWidth: '184px',
        },
        {
          text: this.$t('users.notificationsLang'),
          sortable: true,
          align: 'start',
          value: 'Language',
          search: true,
          forceWidth: '184px',
        },
        {
          text: this.$t('users.notificationsTimezone'),
          sortable: true,
          align: 'start',
          value: 'NotificationTimeZone',
          search: true,
          forceWidth: '184px',
        },
        {
          text: this.$t('users_new.temperatureUnit'),
          sortable: true,
          align: 'start',
          value: 'TemperatureUnit',
          forceWidth: '120px',
        },
        {
          text: this.$t('users.usLastLogin'),
          sortable: true,
          isDateField: true,
          align: 'start',
          value: 'LastLogin',
          forceWidth: '144px',
        },
        {
          text: this.$t('table.actions'),
          value: 'Action',
          sortable: false,
          forceWidth: '80px',
          rwdWidth: {
            mobile: '60px',
            desktop: '80px',
          },
        },
      ]
    },

    updateDataItems(value) {
      this.dataItems = value
    },

    editItem(item) {
      this.editedIndex = this.dataItems.indexOf(item)
    },

    async filterTable() {
      await this.$refs.childTable.filterTable()
    },

    toggleAll() {
      if (this.selected.length > 0) {
        this.selected = []
        this.checkAll = false
      } else {
        this.selected = this.allItemIDs
        this.checkAll = true
      }
    },

    initFilters(filters) {
      this.allOrganizations = filters.Organizations
    },

    editedItemFromTable(item) {
      return this.editItem(item)
    },
  },
}
